import { useQuery } from "@tanstack/react-query";

import { useCurrentOrgId } from "@/providers/auth/hooks";
import { useDomainServices } from "@/providers/DomainServices";
import { PaginatedResponse } from "@/shared/http";

import { AgentThreadRecord } from "../AgentThreadRecord";

interface UseAgentThreadsForUserOptions {
  pageToken?: string;
}

/**
 * Paginated list of the signed-in user's threads within the current org. Backs
 * the agent sidebar's thread history list.
 */
export function useAgentThreadsForUser(
  options?: UseAgentThreadsForUserOptions,
) {
  const { agentThreadService } = useDomainServices();
  const orgId = useCurrentOrgId();

  return useQuery<PaginatedResponse<AgentThreadRecord>, Error>({
    // The list is org-scoped, so ``orgId`` belongs in the key and not only in
    // the request: switching orgs would otherwise serve the previous org's
    // threads from cache.
    queryKey: ["agentThreadsForUser", orgId, options?.pageToken],
    queryFn: ({ signal }) => {
      return agentThreadService.getAgentThreadsForUser({
        pageToken: options?.pageToken,
        abortSignal: signal,
        orgId,
      });
    },
    staleTime: 30_000,
  });
}
